import { MenuIcon, CampaignsIcon, DealsIcon, CartIcon, AudioInputOutputIcon } from 'foundations-assets';
import { ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
export const PREVIOUS_PATH_STORAGE_KEY = 'smart-library-previous-path';
export const ANALYTICS_SUITE_CATEGORY_IDS = {
  RECENTLY_VIEWED: 'recentlyViewed',
  MOST_POPULAR: 'mostPopular',
  RECOMMENDED: 'recommended',
  NEW: 'new'
};
export const ANALYTICS_SUITE_TAB_CONFIG = [{
  icon: MenuIcon,
  tabId: ANALYTICS_SUITE_TAB_IDS.DISCOVER,
  titleKey: 'smartLibrary.analyticsSuite.tabs.discover'
}, {
  icon: CampaignsIcon,
  tabId: ANALYTICS_SUITE_TAB_IDS.MARKETING,
  titleKey: 'smartLibrary.analyticsSuite.tabs.marketing'
}, {
  icon: DealsIcon,
  tabId: ANALYTICS_SUITE_TAB_IDS.SALES,
  titleKey: 'smartLibrary.analyticsSuite.tabs.sales'
}, {
  icon: CartIcon,
  tabId: ANALYTICS_SUITE_TAB_IDS.COMMERCE,
  titleKey: 'smartLibrary.analyticsSuite.tabs.commerce'
}, {
  icon: AudioInputOutputIcon,
  tabId: ANALYTICS_SUITE_TAB_IDS.SERVICE,
  titleKey: 'smartLibrary.analyticsSuite.tabs.service'
}];